<div class="container-box details-box overflow-hidden">
  <div class="py-4 px-3">
    <h6 class="mb-0" i18n>Connection Status</h6>
  </div>
  <!-- Connection Status table -->
  <div class="table-holder table-responsive">
    <table class="table mat-table mb-0">
      <thead>
        <tr class="mat-header-row">
          <th class="mat-header-cell" i18n>Status</th>
          <th class="mat-header-cell" *ngIf="connection?.isExported" i18n>Exported</th>
          <th class="mat-header-cell" *ngIf="connection?.isImported" i18n>Imported</th>
          <th class="mat-header-cell" i18n>Skipped</th>
        </tr>
      </thead>
      <tbody>
        <tr class="mat-row">
          <td class="mat-cell">{{ connection?.statusText }}</td>
          <td class="mat-cell" *ngIf="connection?.isExported">
            {{ connection?.exported || 0 }} <ng-container i18n>Calendar Item(s)</ng-container>
          </td>
          <td class="mat-cell" *ngIf="connection?.isImported">
            {{ connection?.imported || 0 }} <ng-container i18n>Calendar Item(s)</ng-container>
          </td>
          <td class="mat-cell">{{ connection?.skipped || 0 }} <ng-container i18n>Calendar Item(s)</ng-container></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
